<template>
  <div
    class="msg"
    :class="[sideClass, { 'msg--tail': lastOfGroup, 'msg--grouped': !firstOfGroup }]"
    v-if="!isRemark"
    v-observe-visibility="visibilityOptions"
  >
    <!-- системное уведомление -->
    <div class="sys" v-if="isSystem">
      <span>{{ message.content }}</span>
      <time v-if="time"> · {{ time }}</time>
    </div>

    <!-- обычное сообщение -->
    <div class="bubble" v-else>
      <div class="bubble__author" v-if="showAuthor">{{ message.user.name }}</div>

      <p class="bubble__text" v-if="hasText"><template v-for="(token, i) in tokens"><a
          v-if="token.type === 'link'"
          :key="i"
          :href="token.value"
          target="_blank"
          rel="noopener noreferrer nofollow"
        >{{ token.value }}</a><span v-else :key="i">{{ token.value }}</span></template></p>

      <div class="bubble__media" v-if="hasMedia">
        <Files :files="message.media" :align="isMine ? 'right' : 'left'" />
      </div>

      <div class="bubble__meta">
        <span>{{ time }}</span>
        <span class="bubble__sending" v-if="status === 'sending'">· отправляется</span>
        <button class="bubble__retry" v-else-if="status === 'error'" type="button" @click="$emit('retry')">
          · не отправлено, повторить
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Files from './Files.vue';
import { linkifyTokens } from './utils/text';
import { formatTime } from './utils/datetime';

export default {
  name: 'ChatMessage',
  components: { Files },
  props: {
    message: { type: Object, required: true },
    firstOfGroup: { type: Boolean, default: true },
    lastOfGroup: { type: Boolean, default: true },
  },
  computed: {
    isRemark() {
      return !!this.message.remark && this.message.remark.length !== 0;
    },
    userType() {
      return (this.message.user && this.message.user.type) || 'system';
    },
    isMine() {
      return this.userType === 'patient';
    },
    isSystem() {
      return this.userType !== 'patient' && this.userType !== 'doctor' && this.userType !== 'admin';
    },
    sideClass() {
      if (this.isSystem) return 'msg--system';
      return this.isMine ? 'msg--mine' : 'msg--their';
    },
    showAuthor() {
      return (
        this.firstOfGroup &&
        !this.isMine &&
        !this.isSystem &&
        this.message.user &&
        this.message.user.name
      );
    },
    hasText() {
      return !!this.message.content && this.message.content.length > 0;
    },
    hasMedia() {
      return Array.isArray(this.message.media) && this.message.media.length > 0;
    },
    tokens() {
      return linkifyTokens(this.message.content);
    },
    time() {
      return formatTime(this.message.created);
    },
    status() {
      return this.message.status || null;
    },
    visibilityOptions() {
      return {
        callback: (isVisible) => {
          if (isVisible) this.$emit('seen');
        },
        intersection: { threshold: 0.6 },
        throttle: 300,
      };
    },
  },
};
</script>

<style scoped>
.msg {
  display: flex;
  margin-top: 8px;
}

.msg--grouped {
  margin-top: 2px;
}

.msg--mine {
  justify-content: flex-end;
}

.msg--their {
  justify-content: flex-start;
}

.msg--system {
  justify-content: center;
  margin-top: 10px;
}

/* --- системное --- */
.sys {
  font-size: 12px;
  color: var(--text-muted, #6b7681);
  text-align: center;
  padding: 2px 10px;
}

.sys time {
  font-variant-numeric: tabular-nums;
  opacity: 0.8;
}

/* --- пузырь --- */
.bubble {
  max-width: min(78%, 520px);
  padding: 7px 11px;
  border-radius: 14px;
  background: var(--bubble-in, #eef4f7);
  border: 1px solid var(--bubble-in-border, #e0e8ec);
  color: var(--bubble-in-text, #1f2733);
}

.msg--mine .bubble {
  background: var(--bubble-out, #0b89ac);
  border-color: transparent;
  color: var(--bubble-out-text, #fff);
}

.msg--tail.msg--mine .bubble {
  border-bottom-right-radius: 5px;
}

.msg--tail.msg--their .bubble {
  border-bottom-left-radius: 5px;
}

.bubble__author {
  font-size: 12px;
  font-weight: 600;
  color: var(--accent, #0b89ac);
  margin-bottom: 2px;
}

.bubble__text {
  margin: 0;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  font-size: 15px;
  line-height: 1.4;
}

.bubble__text a {
  color: inherit;
  text-decoration: underline;
}

.bubble__media {
  margin-top: 6px;
}

.bubble__meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
  margin-top: 3px;
  font-size: 11px;
  color: var(--text-muted, #6b7681);
  font-variant-numeric: tabular-nums;
}

.msg--mine .bubble__meta {
  justify-content: flex-end;
  color: rgba(255, 255, 255, 0.82);
}

.bubble__retry {
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  font-size: 11px;
  color: var(--danger, #c8352f);
  cursor: pointer;
  text-decoration: underline;
}

.msg--mine .bubble__retry {
  color: #fff;
}
</style>
